import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSave, FaTrash, FaPlus } from "react-icons/fa";

const Success = () => {
  const handleLogout = () => {
    localStorage.removeItem("auth");
    navigate("/");
  };

  const [agents, setAgents] = useState([]);
  const [newAgents, setNewAgents] = useState([]);
  const navigate = useNavigate();
  const [lastAgent, setLastAgent] = useState({});
  const [highestLevel, setHighestLevel] = useState(0);
  const [order, setOrder] = useState([]);

  useEffect(() => {
    const authData = localStorage.getItem("auth");
    if (authData) {
      navigate("/manager");
      operations("list");
    } else {
      navigate("/");
    }
  }, [navigate]);

  const removeAgent = (id) => {
    const agentRemoved = agents.find((persona) => persona.phone.S === id);
    operations("remove", agentRemoved);
    const newStaff = agents.filter((persona) => persona.phone.S !== id);
    setAgents(newStaff);
    getHighestLevel(newStaff);
    reloadPage();
  };

  const saveChanges = () => {
    setLastAgent(agents.pop());
    setAgents((currentAgents) => [...currentAgents, lastAgent]);
    operations("save", lastAgent);
    reloadPage();
  };

  const reloadPage = () => {
    window.location.reload();
  };

  const operations = (action, payload) => {
    let method;
    let body;
    let path;
    switch (action) {
      case "list":
        method = "GET";
        path = "?action=list";
        break;
      case "remove":
        method = "POST";
        body = JSON.stringify({
          Details: {
            Parameters: { action: "remove", body: [payload] },
          },
        });
        path = "";
        action = "";
        break;
      case "save":
        console.log("ok");
        method = "POST";
        body = JSON.stringify({
          Details: {
            Parameters: { action: "save", body: [payload] },
          },
        });
        path = "";
        action = "";
        break;
      default:
        console.log("action not supported");
    }
    fetch(
      `https://q7dgkn7hvh.execute-api.us-east-1.amazonaws.com/${action}${path}`,
      {
        method: method,
        body: body,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (action === "list") {
          getHighestLevel(data);
          setAgents(data);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const getHighestLevel = (data) => {
    let firstArray = [];
    data.forEach((element) => {
      firstArray.push(element.level.N);
    });
    let deduplicatedArray = [...new Set(firstArray)];
    let sortedArray = deduplicatedArray.sort((a, b) => a - b);
    let highestLevelNumber = sortedArray.pop();
    setHighestLevel(highestLevelNumber);
    let orderArray = [[]];
    for (let l = 0; l < highestLevelNumber; l++) {
      orderArray.push([]);
    }
    data.forEach((element) => {
      orderArray[element.level.N].push(element);
    });
    const newOrder = orderArray.map((subarray) => {
      if (subarray.length > 1) {
        return [...subarray].sort((a, b) => a.position.N - b.position.N);
      }
      return subarray;
    });
    setOrder(newOrder);
  };

  const orderByLevel = (data) => {
    let items = agents;
    items.sort((a, b) => a.level.N - b.level.N);
    orderByPosition();
  };

  const orderByPosition = () => {
    const newOrder = order.map((subarray) => {
      if (subarray.length > 1) {
        return [...subarray].sort((a, b) => a.position.N - b.position.N);
      }
      return subarray;
    });
    setOrder(newOrder);
  };

  const update = (event) => {
    //setLastAgent(agents.pop());
    let type;
    if (
      event.target.id === "name" ||
      event.target.id === "lastname" ||
      event.target.id === "phone"
    ) {
      type = "S";
    } else {
      type = "N";
    }
    let newAgent = lastAgent;
    let newValue = {};
    newValue[type] = event.target.value;
    newAgent[event.target.id] = newValue;
    setLastAgent(newAgent);
  };

  const entry = (data, index) => {
    return (
      <tr key={`row-${index}`}>
        <td>
          <p>
            <input
              id="name"
              placeholder="...Nombre"
              defaultValue={data.name.S}
              onChange={update}
            />
          </p>
        </td>
        <td>
          <p>
            <input
              id="lastname"
              placeholder="...Apellido"
              defaultValue={data.lastname.S}
              onChange={update}
            />
          </p>
        </td>
        <td>
          <p>
            <input
              id="phone"
              placeholder="...Teléfono"
              defaultValue={data.phone.S}
              onChange={update}
            />
          </p>
        </td>
        <td className="row-number">
          <p>
            <input id="level" defaultValue={data.level.N} onChange={update} />
          </p>
        </td>
        <td className="row-number">
          <p>
            <input
              id="position"
              defaultValue={data.position.N}
              onChange={update}
            />
          </p>
        </td>
        <td className="row-button">
          <button className="btn" onClick={() => removeAgent(data.phone.S)}>
            <FaTrash />
          </button>
        </td>
      </tr>
    );
  };

  const plus = () => {
    try {
      const newAgent = {
        level: { N: null },
        lastname: { S: "" },
        name: { S: "" },
        phone: { S: "" },
        state: { N: 0 },
        position: { N: null },
      };
      setAgents((currentAgents) => [...currentAgents, newAgent]);
    } catch (error) {
      console.log(error);
    }
  };

  /*const fill = () => {
    agents.pop();
    setAgents((currentAgents) => [...currentAgents, lastAgent]);
  };*/

  const list = (data, index) => {
    if (index > 0) {
      return (
        <div key={index}>
          <div className="level-title">Nivel {index}</div>
          <ol className="agent-data">
            {data.map((item, index) => (
              <li key={index}>
                {item.name.S} {item.lastname.S}
              </li>
            ))}
          </ol>
        </div>
      );
    }
  };

  return (
    <div className="container-block">
      <div className="header">
        <button className="btn" onClick={handleLogout}>
          Salir
        </button>
      </div>
      <div className="left"></div>
      <div className="main">
        <div className="form login-form">
          <table>
            <thead>
              <tr>
                <th style={{ width: "180px" }}>Nombre</th>
                <th>Apellido</th>
                <th>Teléfono</th>
                <th>Nivel</th>
                <th>Posición</th>
                <th>Eliminar</th>
              </tr>
            </thead>
            <tbody>
              {agents.map((item, index) => entry(item, index))}
              <tr>
                <td className="row-button">
                  <button className="btn" onClick={plus}>
                    <FaPlus />
                  </button>
                </td>
              </tr>
              <tr>
                <td className="row-button" colSpan={6}>
                  <button className="plus-btn" onClick={saveChanges}>
                    <FaSave />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="visualization">
          {order.map((item, index) => list(item, index))}
        </div>
      </div>
      <div className="right"></div>
      <div className="footer"></div>
    </div>
  );
};

export default Success;
